/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_AnswerInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can use the link to open the application again, but keep your saved workbook separately. To continue from your own changes, open the downloaded file in the new session. A sample parameter in the URL chooses a starting sample; it is not a reference to your edited copy.`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以通过链接再次打开应用，但应单独保存工作簿。要接着自己的修改继续操作，请在新会话中打开之前下载的文件。网址中的 sample 参数只是选择初始示例，不会指向你编辑过的副本。`)
};

/**
* | output |
* | --- |
* | "You can use the link to open the application again, but keep your saved workbook separately. To continue from your own changes, open the downloaded file in t..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_3_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_3_answer(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_3_answer(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_3_answer as "gc.search_guides.gridcraft_online.sections.7.questions.3.answer" }